(function () {
    'use strict';

    module.exports = DeliveryReturnCtrl;

    DeliveryReturnCtrl.$inject = ["patientService", "purchaseService", "$transition$", "$scope", "stockService", "system", "$state", "$mdToast", "$translate", "$mdDialog", "$q", "configService"];

    function DeliveryReturnCtrl(patientService, purchaseService, $transition$, $scope, stockService, system, $state, $mdToast, $translate, $mdDialog, $q, configService) {

        var vm = this;

        var currentReturn = $transition$.params('to')["returnId"];
        var dateFormat = system['date_format'].js;

        vm.$onInit = init;

        vm.submit = submit;
        vm.invalidateReturn = invalidateReturn;
        vm.validateReturn = validateReturn;
        vm.isAllValid = isAllValid;
        vm.save = save;
        vm.removePatient = removePatient;
        vm.patientCallback = patientCallback;


        function init() {
            vm.is_new = !_.isNil(currentReturn) ? false : true;
            vm.docType = 'DeliveryReturn';
            vm.modalFilter = {is_deleted: {$ne: true}, is_valid: {$ne: false}};
            $scope.$watch('vm.goodReturn.is_valid', readOnlyReturn);
            vm.modelName = 'DeliveryReturn';

            vm.promises = [configService.get(["price_mode"], true), configService.get('store_config')];
            if (!_.isNil(currentReturn)) vm.promises.push(stockService.getStockDocument(currentReturn, 'delivery-return'));
            else vm.goodReturn = {price_mode: 'HT', doc_date: moment().format(dateFormat), lines: []};
            vm.promise = $q.all(vm.promises).then(success);

            function success(data) {
                if (!_.isNil(currentReturn)) vm.goodReturn = data[2];
                else {
                    vm.goodReturn.price_mode = data[0];
                    vm.goodReturn.type = data[1]['return_default_type'] || 'STORE'
                }
            }
        }

        function submit(with_cancel) {
            if (!vm.prevent_save) {
                vm.prevent_save = true;
                vm.promise = vm.save().then(success.bind(this), error.bind(this));
            }

            function success(data) {
                vm.prevent_save = false;
                if (with_cancel) window.history.back();
                else saveSuccess(data);
            }

            function error(err) {
                vm.prevent_save = false;
            }
        }

        function saveSuccess(data) {
            vm.goodReturn = data;
            if (_.isNil(currentReturn)) $state.go('app.stock.delivery-return', {returnId: data.id}, {location: 'replace'});
        }

        function invalidateReturn() {

            if (vm.goodReturn.type == 'PRICE') {
                return stockService.updateStockDocument(vm.goodReturn.id, "delivery-return", {is_valid: false});
            } else {
                return stockService.invalidateMovement(_.get(vm.goodReturn, 'id'), 'DeliveryReturn', 'DeliveryReturn');
            }
        }

        function validateReturn(data) {
            if (vm.goodReturn.type == 'PRICE') {
                return stockService.updateStockDocument(vm.goodReturn.id, "delivery-return", {is_valid: true});
            } else {
                return stockService.validateMovement(_.get(data, 'id'), 'DeliveryReturn', 'DeliveryReturn');
            }
        }

        function readOnlyReturn() {
            vm.readOnly = (vm.goodReturn && vm.goodReturn.is_valid) ? vm.goodReturn.is_valid : false;
        }

        function isAllValid() {
            return vm.goodReturn ? stockService.isAllValid(vm.goodReturn, vm.docType, vm.modelName) : true;
        }

        function save() {
            return stockService.saveStockDocument(vm.goodReturn, "delivery-return", 'DeliveryReturn');
        }

        function removePatient() {
            vm.goodReturn.patient = null;
        }

        function patientCallback(patient) {
            vm.promise = patientService.getMinimalPatient(patient.id, false)
                .then(doneCallback);

            function doneCallback(data) {
                vm.goodReturn.patient = data;
            }
        }
    }
})
();
